import React, { VFC } from 'react';
import { Link, useRouteMatch } from 'react-router-dom';
import { goPage } from '../../redux/slices/historySlice';
import useAppDispatch from '../../hooks/useAppDispatch';

const TabNav: VFC = () => {
  const dispatch = useAppDispatch();
  return (
    <section className="navbar-section">
      <Link className="navbar-brand" to="/">
        <span>Kstadium Bridge</span>
      </Link>
      <Link
        className={`btn btn-link ${
          useRouteMatch(`/bridge`) ? `is-current` : ``
        }`}
        to="/bridge"
      >
        Bridge
      </Link>
      <Link
        className={`btn btn-link ${
          useRouteMatch(`/history`) ? `is-current` : ``
        }`}
        to="/history"
        onClick={() => dispatch(goPage(1))}
      >
        History
      </Link>
    </section>
  );
};

export default TabNav;
